import { useNavigationState, useRoute } from "@react-navigation/native";
import { get, isEqual, snakeCase } from "lodash";
import * as React from "react";

export enum Route {
  Clazzes = "Classes",
  Videos = "Videos",
  Moves = "Moves",
}

function OnlyRoute(onlyRouteName: Route) {
  return ({ children }: React.PropsWithChildren<{}>) => {
    const route = useRoute();
    const [initialRouteName] = React.useState(
      snakeCase(get(route, ["state", "routes", 0, "name"])).replace("_", " ")
    );

    const routeParams = useNavigationState(
      (state) => state.routes?.[0]?.params
    );

    const maybeRouteName = get(routeParams, "screen", initialRouteName);
    const isRoute =
      maybeRouteName?.toLowerCase() === onlyRouteName.toLowerCase();

    if (!isRoute) {
      return null;
    }

    return children;
  };
}

export default {
  Clazzes: OnlyRoute(Route.Clazzes),
  Moves: OnlyRoute(Route.Moves),
  Videos: OnlyRoute(Route.Videos),
};
